import { isConsoleHost } from "./consoleHost";

/**
 * Rotas da aplicação centralizadas.
 */

/** No console as páginas da plataforma ficam na raiz; no app, debaixo de /platform. */
const PLATFORM_BASE = isConsoleHost() ? "" : "/platform";

export const ROUTES = {
  home: "/",
  dashboard: "/dashboard",
  login: "/login",
  submit: "/submit",
  users: "/users",
  projects: "/projects",
  project: (id: string | number) => `/project/${id}`,
  financial: "/financial",
  documentExtractions: "/document-extractions",
  settings: "/settings",
  me: "/me",
  auth: {
    otp: "/auth/otp",
    resetPassword: "/auth/reset-password",
  },
  invitation: (token: string) => `/convite/${encodeURIComponent(token)}`,
  projectCosts: "/project-costs",
  projectDiary: "/project-diary",
  /** @deprecated Unificado em /settings?tab=access (Acessos & Permissões). A rota redireciona. */
  projectPermissions: "/project-permissions",
  /** @deprecated Unificado em /settings?tab=access (Acessos & Permissões). A rota redireciona. */
  projectRoles: "/project-roles",
  /** @deprecated Unificado em /settings?tab=access (Acessos & Permissões). A rota redireciona. */
  permissionsCatalog: "/permissions",
  roles: "/roles",
  stepPurchaseOrders: "/step-purchase-orders",
  systemProfiles: "/system-profiles",
  suppliers: "/suppliers",
  employees: "/employees",
  independentWorkers: "/independent-workers",
  collaborators: "/collaborators",
  tasks: "/tasks",
  crmChat: "/crm/chat",
  contacts: "/crm/contacts",
  adminSubmits: "/admin/submits",
  adminAppBuilds: "/admin/app-builds",
  adminAppHub: "/admin/entregas",
  adminAppHubVersion: (app: string, environment: string, versionName: string) =>
    `/admin/entregas/${app.toLowerCase()}/versoes/${environment}/${encodeURIComponent(versionName)}`,
  deliveryCenter: "/admin/entregas",
  deliveryArea: (product: string, area?: string) =>
    area ? `/admin/entregas/${product}/${area}` : `/admin/entregas/${product}`,
  adminAppDevice: "/admin/app-device",
  adminWebQa: "/admin/entregas/web/testes",
  adminAppReleases: "/admin/app-releases",
  appBuilds: "/admin/app-builds",
  adminErrors: "/admin/errors",
  platformTenants: `${PLATFORM_BASE}/tenants`,
  platformTenantNew: `${PLATFORM_BASE}/tenants/new`,
  platformTenant: (id: string) => `${PLATFORM_BASE}/tenants/${encodeURIComponent(id)}`,
  platformReports: `${PLATFORM_BASE}/reports`,
  platformStorage: `${PLATFORM_BASE}/storage`,
  platformReportTemplates: `${PLATFORM_BASE}/reports/templates`,
  platformReportTemplate: (id: string) => `${PLATFORM_BASE}/reports/templates/${encodeURIComponent(id)}`,
  platformReportPlayground: `${PLATFORM_BASE}/reports/playground`,
  errors: "/admin/errors",
  history: "/history",
  inventory: "/inventory",
  storages: "/inventory",
  storage: (id: string | number) => `/storage/${id}`,
  tickets: "/tickets",
  ticket: (id: string | number) => `/tickets/${id}`,

} as const;
